import { createInvestorOnFounder } from 'api/founderPipeline.api';
import { createInvestor, deleteInvestor, updateInvestor } from 'api/investors.api';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { fetchAndSetInvestorData } from 'components/views/FounderInvestors/_helpers/founderInvestors.resolvers';
import { getBaseTodos } from 'constants';
import { $view, $form } from 'signals/global.signals';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';
import getSelectValue from 'utils/getSelectValue';

/* ------ CRUD EVENTS ------*/
export const handleSubmitCreateInvestor = async () => {
  $view.update({ isModalLoading: true });
  try {
    await createInvestor({
      investorName: $form.value.investorName,
      email: $form.value.email,
      investorType: getSelectValue($form.value.investorType),
      potentialCommitmentMin: Number($form.value.potentialCommitmentMin),
      potentialCommitmentMax: Number($form.value.potentialCommitmentMax),
    });
    displayNotification({
      message: 'Investor created successfully',
      type: 'success',
    });
    handleHideModal();
    await fetchAndSetInvestorData();
  } catch (error) {
    displayError({
      message: 'Failed to create investor. Please check your information and try again.',
      title: 'Investor Creation Error',
    });
  } finally {
    $view.update({ isModalLoading: false });
  }
};

export const handleSubmitAddInvestorToDeal = async () => {
  $view.update({ isModalLoading: true });

  const dealId = getSelectValue($form.value.dealId);

  $view.update({
    isModalLoading: true,
  });
  try {
    const createData = {
      investorId: $form.value.investorId,
      recordType: $form.value.recordType,
      dealId,
      pipelineStatus: getSelectValue($form.value.pipelineStatus),
      amountInvested: $form.value.amountInvested,
      previouslyCommitted: $form.value.previouslyCommitted,
      todos: getBaseTodos(),
    };

    if ($form.value.recordType === 'synced') {
      createData.orgIdInvestor = Number($form.value.investorId);
    } else {
      createData.unsyncedInvestorId = Number($form.value.investorId);
    }
    await createInvestorOnFounder(createData);
    displayNotification({
      message: 'Investor added to deal successfully',
      type: 'success',
    });
    handleHideModal();
    await fetchAndSetInvestorData();
  } catch (error) {
    displayError({
      message: 'Failed to add investor to deal. Please try again.',
      title: 'Add to Deal Error',
    });
  } finally {
    $view.update({ isModalLoading: false });
  }
};

export const handleSubmitEditInvestor = async () => {
  $view.update({ isModalLoading: true });
  try {
    await updateInvestor($form.value.investorId, $form.value.recordType, {
      investorName: $form.value.investorName,
      email: $form.value.email,
      investorType: getSelectValue($form.value.investorType),
      potentialCommitmentMin: Number($form.value.potentialCommitmentMin),
      potentialCommitmentMax: Number($form.value.potentialCommitmentMax),
    });
    displayNotification({
      message: 'Investor updated successfully',
      type: 'success',
    });
    handleHideModal();
    await fetchAndSetInvestorData();
  } catch (error) {
    displayError({
      message: 'Failed to update investor. Please check your information and try again.',
      title: 'Investor Update Error',
    });
  } finally {
    $view.update({ isModalLoading: false });
  }
};

export const handleSubmitDeleteInvestor = async () => {
  $view.update({ isModalLoading: true });
  try {
    await deleteInvestor($form.value.investorId, $form.value.recordType);
    displayNotification({
      message: 'Investor deleted successfully',
      type: 'success',
    });
    handleHideModal();
    await fetchAndSetInvestorData();
  } catch (error) {
    displayError({
      message: 'Failed to delete investor. Please try again.',
      title: 'Investor Deletion Error',
    });
  } finally {
    $view.update({ isModalLoading: false });
  }
};
